import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useShowPopup from '../../hooks/use-show-popup';
import translation from '../../languages';
import SharedModal from '../shared-modal/shared-modal';
import EdukiBannerLogo from './img/promote-app-eduki-logo.svg';
import { PROMOTE_APP_TRACK_EVENTS } from './promote-app.constants';
import { isAppPromotionAllowed, onCloseAppPromotion, onDownload, trackAppPromotionEvent } from './promote-app.helpers';
import './promote-app-modal.scss';

const PromoteAppModal = ({ t }: TranslationProps) => {
    const user = useSelector((state: RootState) => state.main.user);

    const { showModal, setShowModal } = useShowPopup(
        () => onDownload(user?.id ? user.id.toString() : undefined),
        () => onCloseAppPromotion(() => setShowModal(false))
    );

    const defaultBtnConfig = [
        {
            action: () => onDownload(user?.id ? user.id.toString() : undefined),
            className: 'styled yellow download-btn',
            text: t('header.promote-app-banner.buttonText')
        }
    ];

    useEffect(() => {
        setShowModal(isAppPromotionAllowed());
    }, [window.location.pathname]);

    useEffect(() => {
        if (isAppPromotionAllowed()) {
            trackAppPromotionEvent(PROMOTE_APP_TRACK_EVENTS.SHOW);
        }
    }, []);

    return (
        <>
            {showModal && (
                <SharedModal
                    dialogClassName='promote-app-modal'
                    onClose={() => onCloseAppPromotion(() => setShowModal(false))}
                    body={<ModalBody />}
                    btnConfig={defaultBtnConfig}
                    title={<></>}
                    closeOnOutsideClick
                    closeButton
                />
            )}
        </>
    );
};

const translate = translation('header');

const ModalBody = translate(({ t }: TranslationProps) => {
    return (
        <div className='text-center'>
            <p className='eduki-logo'>
                <img src={EdukiBannerLogo} alt='eduki-banner-logo' height={77} width={77} className='banner-logo' />
            </p>
            <div className='tsc-body-highlighted description-dark'>{t('header.promote-app-banner.description')}</div>
        </div>
    );
});

export default translate(PromoteAppModal);
